<template>
  <div class="a-select position-relative mb-4">
    <a-select
      :options="documents"
      label="documentName"
      class="mt-1 awto-select"
      :class="{ 'form-input-internal--error': error }"
      :placeholder="$t('m182')"
      :clearable="false"
      :searchable="false"
      :value="value"
      @input="updateValue"
      :reduce="document => document.id"
    >
      <template #option="{ documentName, code }">
        <div class="select-document-option">
          <a-icon :name="code" class="icon-select" />
          {{ documentName }}
        </div>
      </template>
      <template #selected-option="{ documentName, code }">
        <div style="display: flex; align-items: flex-start;">
          <a-icon :name="code" class="icon-select" />
          {{ documentName }}
        </div>
      </template>
    </a-select>
    <label
      class="form-label-internal"
      :class="{ 'form-label-internal--error': error }"
      >{{ $t('m183') }}</label
    >
    <div class="form-text-validation form-text-validation--error" v-if="error">
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import ASelect from 'vue-select';
import AIcon from '@/components/ui/AIcon';
import 'vue-select/dist/vue-select.css';

export default {
  props: {
    documents: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {},
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    ASelect,
    AIcon,
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="sass">
.select-document-option
  display: flex
  align-items: flex-start
  max-width: 50px
  padding: 0
  margin: 0
.icon-select
  margin-right: 8px
</style>
